// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"32c3ce64","523":"affdc612"}[chunkId] + ".chunk.js";
};